module.exports = __webpack_public_path__ + "img/ui.2ff02c89.png";